import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { Box, IconButton, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Integrations from "../../pages/integrations/Integrations";
import Invitations from "../../pages/integrations/Invitations";
// import InternalInvitations from "../../pages/integrations/InternalInvitations"; // Deshabilitado: clientes ya no tienen estado pending
import InternalIntegrations from "../../pages/integrations/InternalIntegrations";
import MerchantCarrierIntegrations from "../../pages/integrations/Carriers";
import { UserContext } from "../../contexts/userContext";
import {
  INTERNAL,
  MARKETPLACE,
  MERCHANT,
  MERCHANT_TABS_TRANSLATION,
  VALID_MERCHANT_TABS,
} from "../../utils/constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TEntity } from "../../interfaces/userContext";

interface IConfigProps {
  [key: string]: {
    title: string;
    showBackButton: boolean;
    InvitationsComponent?: React.ComponentType<any>;
    IntegrationsComponent: React.ComponentType<any>;
    showCarriersTab: boolean;
  };
}

const ENTITY_CONFIG: { [key: string]: IConfigProps[string] } = {
  [INTERNAL]: {
    title: "Clientes",
    showBackButton: false,
    // InvitationsComponent: InternalInvitations, // Deshabilitado: clientes ya no tienen estado pending
    IntegrationsComponent: InternalIntegrations,
    showCarriersTab: false,
  },
  [MARKETPLACE]: {
    title: "Merchants",
    showBackButton: false,
    InvitationsComponent: Invitations,
    IntegrationsComponent: Integrations,
    showCarriersTab: true,
  },
  [MERCHANT]: {
    title: "Marketplaces",
    showBackButton: true,
    InvitationsComponent: Invitations,
    IntegrationsComponent: Integrations,
    showCarriersTab: false,
  },
};

const getConfigByEntity = (entity: TEntity) => ENTITY_CONFIG[entity];

const IntegrationsTabs = () => {
  const {
    currentUser: { entity, merchantId },
    getIntegrationsOfMerchant,
  } = useContext(UserContext);
  const [value, setValue] = useState(entity === INTERNAL ? "administration" : "invitations");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("vista") as string;
  const handleChange = (_event: SyntheticEvent, newValue: string) =>
    setValue(newValue);

  const configuration = getConfigByEntity(entity);

  useEffect(() => {
    const translatedInitialTabName =
      MERCHANT_TABS_TRANSLATION[initialTab?.toLowerCase()];

    if (VALID_MERCHANT_TABS.includes(translatedInitialTabName))
      setValue(translatedInitialTabName);
  }, []);

  const commonProps = {
    entity,
    merchantId,
    getIntegrationsOfMerchant,
  };

  return (
    <>
      <Box display="flex" alignItems="center">
        {configuration.showBackButton && (
          <IconButton onClick={() => navigate(-1)}>
            <span className="material-symbols-rounded text-dark">
              keyboard_backspace
            </span>
          </IconButton>
        )}
        <Typography ml={1} className="f-s-20">
          Gestión de {configuration.title}
        </Typography>
      </Box>

      <TabContext value={value}>
        <Box
          className="m-t-30"
          sx={{ borderBottom: 1, borderColor: "divider", width: "fit-content" }}
        >
          <TabList onChange={handleChange}>
            {configuration.InvitationsComponent && (
              <Tab label="Invitaciones" value="invitations" />
            )}
            <Tab label="Administración" value="administration" />
            {configuration.showCarriersTab && (
              <Tab label="Operadores" value="carriers" />
            )}
          </TabList>
        </Box>
        {configuration.InvitationsComponent && (
          <TabPanel value="invitations">
            <configuration.InvitationsComponent
              {...(entity !== INTERNAL && commonProps)}
            />
          </TabPanel>
        )}
        <TabPanel value="administration">
          <configuration.IntegrationsComponent
            {...(entity !== INTERNAL && { entity, getIntegrationsOfMerchant })}
          />
        </TabPanel>
        {configuration.showCarriersTab && (
          <TabPanel value="carriers">
            <MerchantCarrierIntegrations />
          </TabPanel>
        )}
      </TabContext>
    </>
  );
};

export default IntegrationsTabs;
